/* AWOL · ÍNDICE
   Cambio de colección sin recargar y control de densidad de la retícula. */
document.querySelectorAll('[data-awol-catalogo]').forEach(function (raiz) {
  var pestanas = raiz.querySelectorAll('[data-awol-pestana]');
  var paneles = raiz.querySelectorAll('[data-awol-panel]');
  var pasos = raiz.querySelectorAll('[data-awol-densidad]');
  function mostrar(id) {
    paneles.forEach(function (panel) {
      var activo = panel.getAttribute('data-awol-panel') === id;
      panel.hidden = !activo;
    });
    pestanas.forEach(function (pestana) {
      pestana.setAttribute(
        'aria-pressed',
        String(pestana.getAttribute('data-awol-pestana') === id)
      );
    });
  }

  pestanas.forEach(function (pestana) {
    pestana.addEventListener('click', function () {
      mostrar(pestana.getAttribute('data-awol-pestana'));
    });
  });

  pasos.forEach(function (paso) {
    paso.addEventListener('click', function () {
      var columnas = paso.getAttribute('data-awol-densidad');
      raiz.closest('.shopify-section, body').style.setProperty('--columnas-escritorio', columnas);
      pasos.forEach(function (otro) {
        otro.setAttribute('aria-pressed', String(otro === paso));
      });
      try {
        localStorage.setItem('awol:densidad', columnas);
      } catch (e) {
        /* sin almacenamiento, la densidad vive solo en esta vista */
      }
    });
  });

  try {
    var guardada = localStorage.getItem('awol:densidad');
    if (guardada) {
      var elegido = raiz.querySelector('[data-awol-densidad="' + guardada + '"]');
      if (elegido) elegido.click();
    }
  } catch (e) {
    /* idem */
  }
});
